import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionEmpleadoComponent {
  data
  guardando = false
  activarGuardar = false
  vincular = false

  constructor ($q, ViaticosProyectos, ViaticosProyectosColaboradores, ViaticosProyectosColaboradorCuentasContables, ViaticosProyectosColaboradorCuentaContable, $notify) {
    this.$q = $q
    this.ViaticosProyectos = ViaticosProyectos
    this.ViaticosProyectosColaboradores = ViaticosProyectosColaboradores
    this.ViaticosProyectosColaboradorCuentasContables = ViaticosProyectosColaboradorCuentasContables
    this.ViaticosProyectosColaboradorCuentaContable = ViaticosProyectosColaboradorCuentaContable
    this.$notify = $notify
  }

  $onInit () {
    this.promise = this.$q.all({
      proyectos: this.ViaticosProyectos.get(),
    }).then(({proyectos}) => {
      this.proyectos = proyectos.data
    })
  }

  traerEmpleados () {
    this.trayendoEmpleados = true
    this.data.id_colaborador = undefined
    this.data.cuenta_contable = undefined
    this.ViaticosProyectosColaboradores.get(this.data.id_proyecto).then(({data}) => {
      this.colaboradores = data
      this.trayendoEmpleados = false
    })
  }

  traerProyectos () {
    this.data.id_proyecto = undefined
    this.data.id_colaborador = undefined
    this.data.cuenta_contable = undefined
    this.ViaticosProyectos.get(this.data.id_pagadora).then(({data}) => (this.proyectos = data))
  }

  guardar () {
    this.guardando = true
    this.data.tipo_cuenta = 'V'
    this.ViaticosProyectosColaboradorCuentasContables.post(this.data)
      .then(() => {
        this.guardando = false
        this.activarGuardar = false
        this.$notify.success('Se ha guardado la información')
      })
  }

  traerCuentaContable () {
    this.data.tipo_cuenta = 'V'
    this.ViaticosProyectosColaboradorCuentaContable.get(this.data.id_proyecto, this.data.id_colaborador, this.data.tipo_cuenta)
      .then(({data}) => {
        this.activarGuardar = false
        this.data.cuenta_contable = data.cuenta_contable || undefined
      })
  }
}

module.component('viaticosConfiguracionEmpleado', {
  controller: ViaticosConfiguracionEmpleadoComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/empleado/component.js